import { HCP_CUBE_NAME } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { FilterConfigDynamic } from '@/types/filter';

const DIMENSION = `${HCP_CUBE_NAME}.primary_point_of_contact`;

const consentPpocFilter: FilterConfigDynamic = {
  label: 'main.aggregatedConsent.filters.ppoc.label',
  placeholder: 'main.aggregatedConsent.filters.ppoc.placeholder',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  useFloatingLabel: true,
  sourceCube: HCP_CUBE_NAME,
  getOptionsQuery: () => ({
    dimensions: [DIMENSION],
    limit: 1000,
    filters: [],
  }),
  mapResult: mapDimensionToOption(DIMENSION, value => (value === 'N/A' ? 'Not defined' : value)),
  applyFilter: value => {
    const v = value as string[];
    if (!v?.length) return undefined;
    return { member: DIMENSION, operator: 'equals', values: [...v] };
  },
};

export default consentPpocFilter;
